import styled from 'styled-components';

const Footer = styled.footer`
  color: #e3e6e7;
  font-size: 13px;
  line-height: 22px;
  width: 100%;
  align-self: flex-end;
  background-color: ${({ theme }) => theme.colors.opal12};
`;
export default Footer;

export const FooterDivider = styled.div`
  width: 100%;
  border-bottom: 1px solid #446583;
  margin-top: 35px;
  margin-bottom: 25px;
`;

export const FooterHeader = styled.p`
  font-size: 16px !important;
  font-weight: bold;
  margin: 0 0 11px 0;
  color: #70a0ca;
`;
